<template>
  <div>
    <div v-if="validation.$error">
      <p class="text-danger font-weight-bolder" v-for="$error in validation.$errors" :key="$error.$property">
        {{ translateError($error) }}
      </p>
    </div>

  </div>
</template>

<script>
import {i18n} from "@/main";
import {templateSettings} from "lodash";

templateSettings.interpolate = /{{([\s\S]+?)}}/g;

export default {
  name: 'FormErrorsManager',
  data() {
    return {
      errors: [],
      i18n
    }
  },
  props: {
    validation: {
      type: Object,
      required: true
    },
  },
  computed: {
    translations() {
      return i18n.global.messages[i18n.global.locale]['validation'];
    }
  },
  methods: {
    translateError(error) {
      let translateError = this.translations[error.$validator];
      Object.keys(error.$params).forEach(item => {
        if (item != 'type') {
          translateError = translateError.replace(`{{${item}}}`, error.$params[item])
        }
      })
      return translateError

    }
  }
}
</script>